import isEqual from 'lodash/isEqual';
import routeSettingsDefaults from "@data/routeSettingsDefaults";
import poiSettingsDefaults from "@data/poiSettingsDefaults";

export function setPoiSettings(state, payload) {
    state.poiSettingsChanged = comparePoiSettings(payload)
    state.poiSettings = payload;
}

export function setQueryPoiSettings(state, payload) {
    state.queryPoiSettingsChanged = Object.keys(payload).length > 0 && comparePoiSettings(payload)
    state.queryPoiSettings = payload
}

export function setRouteSettings(state, payload) {
    state.routeSettingsChanges = [];
    state.routeSettingsChanges = compareRouteSettings(payload)
    state.routeSettingsChanged = state.routeSettingsChanges?.length > 0;

    state.routeSettings = payload;
}

export function setSavedRouteSettingsChanges(state, payload) {
    state.savedRouteSettingsChanges = [];
    if(!isEqual(routeSettingsDefaults, payload)) {
        Object.keys(routeSettingsDefaults).forEach(route => {
            if(!isEqual(routeSettingsDefaults[route], payload[route])) state.savedRouteSettingsChanges.push(route.toLocaleUpperCase())
        })
        state.savedRouteSettingsChanges = [...state.savedRouteSettingsChanges];
    }

}

export function setSavedRouteSettings(state, payload) {
    state.savedRouteSettings = payload
}

export function setQueryRouteSettings(state, payload) {
    state.queryRouteSettings = payload
}

export function setQueryRouteSettingsChanges(state, payload) {
    state.queryRouteSettingsChanges = []
    if(!isEqual(routeSettingsDefaults, payload)) {
        Object.keys(routeSettingsDefaults).forEach(route => {
            if(!isEqual(routeSettingsDefaults[route], payload[route])) state.queryRouteSettingsChanges.push(route.toLocaleUpperCase())
        })
        state.queryRouteSettingsChanges = [...state.queryRouteSettingsChanges];
    }
}

export function setRouteTrafficTime(state, payload) {
    state.routeTrafficTime = payload
}

export function setSavedRouteTime(state, payload) {
    state.savedRouteTime = payload
}

export function setRouteCorridorRadius(state, payload) {
    state.routeCorridorRadius = payload
}

export function setGasConsumptionSettings(state, payload) {
    state.gasConsumptionSettings = payload
}

function comparePoiSettings(payload) {
    const changedPoiCategories = []
    Object.keys(poiSettingsDefaults).forEach(poi => {
        if (poi === 'gasStations') {
            const gasStationDefaults = Object.assign({}, poiSettingsDefaults[poi])
            delete gasStationDefaults.fuels
            const gasStationPayload = Object.assign({}, payload[poi])
            delete gasStationPayload.fuels
            if(!isEqual(gasStationDefaults, gasStationPayload)) changedPoiCategories.push(poi)
        } else {
            if(!isEqual(poiSettingsDefaults[poi], payload[poi])) changedPoiCategories.push(poi)
        }
    })
    return changedPoiCategories
}

function compareRouteSettings(payload) {
    const changedRouteModes = []
    Object.keys(routeSettingsDefaults).forEach(routeMode => {
        const defaultItem = Object.assign({}, routeSettingsDefaults[routeMode])
        const payloadItem = Object.assign({}, payload[routeMode])
        if(!isEqual(defaultItem, payloadItem)) changedRouteModes.push(routeMode.toLocaleUpperCase())
    })
    return changedRouteModes
}